import clientApi, { IClientApiResponse } from '~/clientApi';
import { Creator } from '~/clientApi/creator.model';

export interface ICreatorsParams {
  agencyId?: string;
  keyword?: string;
  page?: number;
  pageSize: number;
}

export const getCreators = async ({
  agencyId,
  keyword,
  page = 1,
  pageSize,
}: ICreatorsParams): Promise<IClientApiResponse<Creator>> => {
  const filter: string[] = [];

  if (keyword) {
    filter.push(`keyword:${keyword}`);
  }

  if (agencyId) {
    return clientApi.getAgencyCreators({
      agencyId,
      filters: filter,
      page,
      pageSize,
    });
  }

  return clientApi.creators.index({
    filter,
    page,
    pageSize,
    _isImpersonatingDisabled: true,
  });
};
